import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import StreamingChartItem from '@/features/streaming-charts/components/StreamingChartItem.vue';
import { streamingChartLandingPageCountries } from '@/components/details/streaming-chart/streaming-chart-config';
import { NormalizedChartTitle } from '@/features/streaming-charts/streaming-charts-helper';

import { ObjectType } from '@/@types/graphql-types';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'StreamingChartList',
  props: {
    titles: null,
    titleId: { default: '' },
    titleObjectType: null,
    lastUpdated: null,
    isSidebar: { type: Boolean, default: false },
    hideHeader: { type: Boolean, default: false },
    hideLandingPageLink: { type: Boolean, default: false },
    hideLastUpdated: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { titles: NormalizedChartTitle[], titleId: string, titleObjectType?: ObjectType, lastUpdated?: string | number | Date, isSidebar: boolean, hideHeader: boolean, hideLandingPageLink: boolean, hideLastUpdated: boolean };



const { country, language } = storeToRefs(useLanguageStore());

function formatUtcTimestamp(value: string | number | Date): string {
	const d = new Date(value);
	if (isNaN(d.getTime())) return '';
	const date = new Intl.DateTimeFormat(`${language.value}-${country.value}`, {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
		timeZone: 'UTC',
	}).format(d);
	const time = new Intl.DateTimeFormat(`${language.value}-${country.value}`, {
		hour: '2-digit',
		minute: '2-digit',
		hour12: false,
		timeZone: 'UTC',
	}).format(d);
	return `${time}, ${date}`;
}

const showChart = computed(() => props.titles.length > 0);

const updatedTimestamp = computed(() => formatUtcTimestamp(props.lastUpdated ?? ''));

const showLinkButton = computed(
	() =>
		!!streamingChartLandingPageCountries.includes(country.value) &&
		language.value === 'en' &&
		!props.hideLandingPageLink
);

const linkButtonText = computed(() => {
	if (props.titleObjectType === ObjectType.Movie) return 'Show all movies in the JustWatch Streaming Charts';
	if (props.titleObjectType === ObjectType.Show) return 'Show all TV shows in the JustWatch Streaming Charts';
	if (props.titleObjectType === ObjectType.ShowSeason) return 'Show all seasons in the JustWatch Streaming Charts';
	return 'Show all titles in the JustWatch Streaming Charts';
});

const linkButtonQueryParams = computed(() => {
	let objectTypeQueryParam = undefined;
	if (props.titleObjectType === ObjectType.Show) objectTypeQueryParam = 'shows';
	if (props.titleObjectType === ObjectType.ShowSeason) objectTypeQueryParam = 'seasons';
	return {
		t: objectTypeQueryParam,
		ct: 'daily',
	};
});

function trackLinkClick() {
	TrackingHelper.trackEvent('userinteraction', {
		action: 'redirect_clicked',
		label: 'streaming_chart',
	});
}

return { __sfc: true,props, country, language, formatUtcTimestamp, showChart, updatedTimestamp, showLinkButton, linkButtonText, linkButtonQueryParams, trackLinkClick, StreamingChartItem }
}

})